export default {"src":"/_next/static/image/public/images/ic_1Aster_Exclusive.163271f3ba2b7d3701cf1fdf4e4d3965.svg","height":22,"width":127};